import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { AuthTextInputProps } from "../../../interface/types";
import { InputAdornment } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const AuthTextInput: React.FC<AuthTextInputProps> = ({
  label,
  placeholder,
  icon,
  autoFocus,
  onChange,
  name,
  value,
  types,
  page,
  customStyle = {},
  module,
  required,
  disable
}) => {
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const { backgroundColor, border, flexDirection }: any = customStyle;
  const handlePassword = () => {
    setPasswordShow(!passwordShow);
  };

  const handleChange = (e:any) => {
    if (onChange) {
      onChange(module === "invoice" ? e.target.value : e); // Call the prop with just the value
    }
  };

  return (
    <div
      className={`!mt-[2rem] w-full flex items-center flex-${
        flexDirection || "col"
      } ${flexDirection && "gap-4"} justify-center `}
    >
      <label
        className={`text-textGray text-[0.8rem] !mb-[0.5rem] flex gap-2 ${
          page === "settings" ? "self-start text-left" : ""
        } ${flexDirection && "min-w-[6rem]"}`} 
      >
        {label}
        {module === "invoice" && required && <span className="text-red-500">*</span>}
      </label>

      <TextField
        placeholder={placeholder}
        type={types === "password" && passwordShow ? "text" : types}
        autoFocus={autoFocus}
        fullWidth
        value={value}
        name={name}
        disabled={disable}
        onChange={handleChange}
        variant="outlined"
        className="w-full"
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "2.3rem",
            paddingRight: "0.5rem",
            backgroundColor: backgroundColor ?? "#EEEEEE",
            "& fieldset": {
              border: border ?? "none",
            },
          },
          "& input": {
            fontSize: "0.8rem",
            padding: "0.5rem 0.5rem",
          },
        }}
        inputProps={
          types === "password" ? { maxLength: 15 } : { maxLength: 250 }
        }
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {types === "password" ? (
                <div
                  onClick={handlePassword}
                  className="cursor-pointer !w-[1.2rem]  !mr-[0.5rem]"
                >
                  {passwordShow ? (
                    <VisibilityOutlinedIcon
                      fontSize="small"
                      sx={{ opacity: 0.6 }}
                    />
                  ) : (
                    <VisibilityOffOutlinedIcon
                      fontSize="small"
                      sx={{ opacity: 0.6 }}
                    />
                  )}
                </div>
              ) : icon ? (
                <img
                  src={icon}
                  alt="icon"
                  className="w-[1.2rem]  opacity-60 !mr-[0.5rem]"
                />
              ) : null}
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default AuthTextInput;
